// This file is used to define roles of users based on username.
// All logic and definitions are defined in the frontend to avoid massive rework of OSB auth backend logic.

const userRolesEnum = {
  myTReportAccess: 'myTReportAccess',
  admin: 'admin',
  tpo: 'tpo_manager',
};

const userList = [{ username: 'myToyota', roles: [userRolesEnum.myTReportAccess] }];

let userRoles = [];

/**
 *
 * @param {String} username to search for. If not found then assumes it has admin access
 */
const findUserRole = username => {
  const users = userList.filter(user => user.username === username);
  if (users.length) return users[0].roles;

  return [userRolesEnum.admin, userRolesEnum.tpo];
};

/**
 *sampleClientId
 * @param {String} rolesToFind
 * @param {String[]} userRoles
 */
const hasRole = (rolesToFind = [], userRoles = []) => {
  let found = false;

  for (const roleToFind of rolesToFind) {
    // incase userRoles is set to null
    if ((userRoles || []).includes(roleToFind)) found = true;
  }

  return found;
};

const storeUserPermissions = permissions => localStorage.setItem('userRoles', permissions);
const getUserPermissions = () => localStorage.getItem('userRoles');
const userIsAdmin = () => hasRole([userRolesEnum.admin], getUserPermissions());
const userCanUseTPO = () => hasRole([userRolesEnum.admin, userRolesEnum.tpo], getUserPermissions());

export {
  findUserRole,
  userRolesEnum,
  hasRole,
  storeUserPermissions,
  getUserPermissions,
  userIsAdmin,
  userCanUseTPO,
};



// WEBPACK FOOTER //
// ./src/utils/RolesBasedUsers.js